/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PeriodBundlesStatusSummaryContract} from '../../../api/contracts/period/period-bundles-status-summary.contract';
import {PeriodBundlesStatusSummaryModel} from './period-bundles-status-summary.model';

export class PeriodBundlesStatusSummaryMapper {
    static fromPeriodDetailContract(input: PeriodBundlesStatusSummaryContract): PeriodBundlesStatusSummaryModel {
        let model: PeriodBundlesStatusSummaryModel;

        if (input != null) {
            model = {
                open: input.open,
                closed: input.closed,
                total: input.total
            };
        }
        return model;
    }
}
